<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="showAddStockDialog" color="primary float-right"
            >Stok Ekle</v-btn
          >
          <!-- Stok Ekle Butonu -->
        </v-col>
      </v-row>

      <v-dialog v-model="addStockDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Stok Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newStock.name"
                    label="Ürün Adı"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="newStock.sku"
                    label="SKU"
                    :rules="[rules.required, rules.sku]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="newStock.category_id"
                    :items="categoryList"
                    label="Kategoriler"
                    item-value="id"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    @input="getModel(newStock.brand_id)"
                    v-model="newStock.brand_id"
                    :item-props="brandProps"
                    :items="brandList"
                    item-text="text"
                    item-value="value"
                    label="Marka"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="newStock.model_id"
                    :item-props="modelProps"
                    :items="modelList"
                    item-text="text"
                    item-value="value"
                    label="Model"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addStock">Ekle</v-btn>
            <v-btn color="grey" text @click="addStockDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="getStockMovementListDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Stok Hareketleri</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="stockMovementsheaders"
              :items="stockMovementList"
              :items-per-page="10"
              class="elevation-1"
              :loading="loading"
              :search="search"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{stockName}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    label="Ara..."
                    class="mx-4"
                    solo
                    clearable
                  ></v-text-field>
                </v-toolbar>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.color.name }}</td>
                  <td>{{ item.serial_number }}</td>
                  <td>
                    <v-badge v-if="item.status === 'available'" color="green" content="Mevcut"> </v-badge>
                    <v-badge v-if="item.status === 'sold'" color="red" content="Satıldı"> </v-badge>
                    <v-badge v-if="item.status === 'reserved'" color="orange" content="Rezerve Edildi"> </v-badge>
                  </td>
                  <td class="text-end">{{ formatCurrency(item.selling_price) }} ₺</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
           
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="stockList"
            :items-per-page="10"
            class="elevation-1"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Stok Listesi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.brand.name }}</td>
                <td>{{ item.model.name }}</td>
                <td>{{ item.stock_movements.length }}</td>
                <td class="text-end">
                  <v-btn
                    size="30"
                    @click="addStockMovements(item.id)"
                    color="blue"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-plus</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="getStockMovements(item.id)"
                    color="green"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-view-list</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="deleteStock(item.id)"
                    color="red"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="editStock(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import { useFetch } from "@/composables/useFetch";

export default {
  name: "StockList",
  components: {
    MainLayout,
  },
  created() {
    this.fetchStockList();
    this.getBrand();
    this.getColor();
  },
  data() {
    return {
      getStockMovementListDialog :false,
      stockName :'',
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Stok Kartları",
          disabled: false,
          href: "",
        },
      ],
      stockMovementsheaders: [
     
        {
          title: "Renk",
          value: "color_id",
        },
        {
          title: "Seri Numarası",
          value: "serial_number",
        },
        {
          title: "Durum",
          value: "status",
        },
        {
          title: "Satış Fiyatı",
          sortable: false,
          align: "end",
        }, // Aksiyonlar için
      ],
      headers: [
        {
          title: "Stok Adı",
          value: "name",
        },

        {
          title: "Marka",
          value: "brand_id",
        },
        {
          title: "Model",
          value: "model_id",
        },
        {
          title: "Adet",
          value: "quantity",
        },
        {
          title: "İşlemler",
          value: "actions",
          sortable: false,
        }, // Aksiyonlar için
      ],
      select: {
        name: "Seçiniz",
        id: "0",
      },
      stockList: [],
      modelList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
      addStockDialog: false, // Stok ekleme modal durumu
      newStock: {
        // Yeni stok bilgileri
        name: "",
        sku: "",
        brand_id: "",
        model_id: "",
        category_id: "",
      },

      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
        sku: (value) =>
          /^[A-Z0-9]{1,8}$/.test(value) ||
          "SKU sadece büyük harf ve sayı içerebilir, maksimum 8 karakter olmalıdır.",
      },
      statusItems: [
        {
          text: "Aktif",
          value: 1,
        },
        {
          text: "Pasif",
          value: 0,
        },
      ],
    };
  },
  setup() {
    const {
      data: categoryList,
      loadingCategory,
      error,
      fetchData,
    } = useFetch("categories");

    fetchData(); // Veriyi çek

    return {
      categoryList,
      loadingCategory, // Burada loading'ı doğrudan kullanıyoruz
      error,
    };
  },
  watch: {
    "newStock.brand_id": function (newVal) {
      this.getModel(newVal);
    },
  },
  computed: {
    ...mapState(["Stock"]), // Vuex state'inden Stock'ı al
  },
  methods: {
    addStockMovements(StockId){
      Swal.fire({
        title: 'Stok Hareketleri',
        text: 'Stok Hareketleri ekleniyor...'+StockId+'',
        icon: 'info',
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    showAddStockDialog() {
      this.resetNewStock(); // Formu sıfırla
      this.addStockDialog = true; // Modalı göster
    },
    itemProps(colorList) {
      return {
        title: colorList.name,
        value: colorList.id,
        subtitle: colorList.hex_code,
      };
    },
    modelProps(modelList) {
      return {
        title: modelList.name,
        value: modelList.id,
      };
    },

    brandProps(brandList) {
      return {
        title: brandList.name,
        value: brandList.id,
      };
    },
    fetchStockList() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("stocks")
        .then((response) => {
          console.log(response);
          this.stockList = response; // Stok listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    getBrand() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("brands")
        .then((response) => {
          console.log(response);
          this.brandList = response; // Stok listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    getModel(BrandId) {
      const BrandToList = this.brandList.find((Brand) => Brand.id === BrandId);
      if (BrandToList) {
        this.modelList = BrandToList.models || []; // İlişkili modelleri al
      } else {
        this.modelList = []; // Eğer marka bulunamazsa model listesini temizle
      }
    },

    async getColor() {
      this.loading = true; // Yükleniyor durumunu başlat
      mainService
        .list("colors")
        .then((response) => {
          this.colorList = response; // Stok listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },

    async addStock() {
      if (this.$refs.form.validate()) {
        // Formu doğrula
        try {
          await mainService.add(this.newStock, "stocks"); // Yeni stokyı ekle
          this.fetchStockList(); // Stok listesini güncelle
          this.addStockDialog = false; // Modalı kapat
          Swal.fire("Eklendi !", "Stok başarıyla eklendi.", "success");
          this.resetNewStock(); // Yeni stok formunu sıfırla
        } catch (error) {
          console.error("Stok eklenirken hata oluştu:", error);
        }
      }
    },

    async editStock(StockId) {
      // Stok bilgilerini al
      const StockToEdit = this.stockList.find((Stock) => Stock.id === StockId);
      if (StockToEdit) {
        this.newStock = {
          ...StockToEdit,
        }; // Stok bilgilerini form alanlarına doldur
        this.addStockDialog = true; // Modalı aç
      }
    },

    async getStockMovements(StockId) {
      // Stok bilgilerini al
      const StockToEdit = this.stockList.find((Stock) => Stock.id === StockId);
      if (StockToEdit) {
        this.newStock = {
          ...StockToEdit,
        }; // Stok bilgilerini form alanlarına doldur
        // İlişkili modelleri listele
        console.log(StockToEdit.models);

        this.stockName = StockToEdit.name;
        this.stockMovementList = StockToEdit.stock_movements || []; // İlişkili modelleri al
        this.getStockMovementListDialog = true; // Modalı aç
      }
    },

    async deleteStock(StockId) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Silmek istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          await mainService.delete(StockId, "stocks"); // Stokyı silmek için servisi çağır
          this.fetchStockList(); // Stok listesini güncelle
          Swal.fire("Silindi!", "Stok başarıyla silindi.", "success");
        } catch (error) {
          console.error("Stok silinirken hata oluştu:", error);
          Swal.fire("Hata!", "Stok silinirken bir hata oluştu.", "error");
        }
      } else {
        Swal.fire("İptal edildi", "Stok silme işlemi iptal edildi.", "info");
      }
    },
    resetNewStock() {
      this.newStock = {
        name: "",
        sku: "",
        brand_id: "",
        model_id: "",
        category_id: "",
      };
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
